__turbopack_context__.v({
  "button": "It9yFG_button",
  "danger": "It9yFG_danger",
  "ghost": "It9yFG_ghost",
  "labelContent": "It9yFG_labelContent",
  "labelPhase": "It9yFG_labelPhase",
  "labelSlot": "It9yFG_labelSlot",
  "lg": "It9yFG_lg",
  "loader": "It9yFG_loader",
  "loadingLabel": "It9yFG_loadingLabel",
  "md": "It9yFG_md",
  "primary": "It9yFG_primary",
  "secondary": "It9yFG_secondary",
  "sm": "It9yFG_sm",
  "spin": "It9yFG_spin",
  "spinner": "It9yFG_spinner",
});
